// Market/location pages for SEO across the consultancy's core geographies.
export const MARKETS = {
  uae: {
    slug: "uae",
    region: "United Arab Emirates",
    hero: "HR Governance & People Risk Advisory in the UAE",
    intro:
      "From Dubai and Abu Dhabi to the DIFC and ADGM, organisations in the UAE operate under fast-evolving labour regulation and heightened governance expectations. Irina Ishik provides discreet, senior advisory to boards, CEOs and CHROs navigating disciplinary frameworks, investigations, restructuring and people risk in a demanding, multicultural, highly regulated environment.",
    highlights: [
      "Governance and disciplinary frameworks simplified for Dubai, Abu Dhabi and free-zone entities (DIFC, ADGM).",
      "Independent handling of sensitive misconduct investigations and senior-leader matters.",
      "People risk diagnostics and restructuring support for rapid-growth and regulated businesses.",
    ],
    meta:
      "Senior HR governance, people risk and advisory consulting in the UAE (Dubai, Abu Dhabi, DIFC, ADGM). Discreet board-level support for investigations, restructuring and regulated-market HR.",
  },
  europe: {
    slug: "europe",
    region: "Europe",
    hero: "HR Governance & People Risk Advisory across Europe",
    intro:
      "European organisations face some of the world's most complex people governance — from works councils and GDPR to multi-jurisdiction employment law and regulatory scrutiny. With HR governance experience spanning 12 countries and representation in regulatory reviews, Irina Ishik advises boards and executives on conduct, culture and change with rigour and discretion.",
    highlights: [
      "HR governance and conduct-risk frameworks for regulated, multi-jurisdiction operations.",
      "Support through mergers, integration and restructuring with defensible, fair process.",
      "Advisory on sensitive senior-leader and cross-border employee-relations matters.",
    ],
    meta:
      "HR governance, people risk and advisory consulting across Europe. Multi-jurisdiction conduct-risk frameworks, integration, restructuring and board-level advisory with complete discretion.",
  },
  turkey: {
    slug: "turkey",
    region: "Turkey",
    hero: "HR Governance & People Risk Advisory in Turkey",
    intro:
      "Turkish and cross-border organisations bridging Europe and the Middle East require HR governance that respects local labour law while meeting international standards. Irina Ishik brings senior, culturally fluent advisory to boards and executives managing people risk, organisational change and complex employee-relations matters in Turkey and the wider region.",
    highlights: [
      "HR governance aligned to Turkish labour law and international best practice.",
      "People risk, restructuring and organisational change advisory for cross-border groups.",
      "Discreet handling of high-stakes leadership and employee-relations matters.",
    ],
    meta:
      "HR governance, people risk and advisory consulting in Turkey. Culturally fluent, senior board-level support for organisational change, restructuring and complex employee relations.",
  },
};

export const MARKET_LIST = Object.values(MARKETS);
